export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20of%20assorted%20fashion%20products%20including%20sneakers%20accessories%20and%20clothing%20arranged%20in%20an%20artistic%20asymmetrical%20composition%20on%20textured%20ivory%20paper%2C%20warm%20golden%20hour%20backlighting%20creating%20long%20soft%20shadows%2C%20premium%20lifestyle%20catalog%20aesthetic%2C%20elegant%20modern%20composition%20with%20organic%20spacing%2C%20refined%20neutral%20color%20palette%20with%20subtle%20warm%20accents&width=1920&height=1080&seq=hero-bg-main-v2-02&orientation=landscape"
          alt="Hipobuy Spreadsheet fashion product discovery background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
            <i className="ri-sparkling-line text-sm"></i>
            <span>Updated Product Research Resource</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
            Hipobuy Spreadsheet —
            <br />
            <span className="text-primary-500 italic">The Ultimate Product</span>
            <br />
            Discovery &amp; Buying Guide
          </h1>

          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover organized Hipobuy spreadsheet resources, product categories, comparison guides, 
            QC tips, and updated shopping insights designed to help buyers find better products faster.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              hipobuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold text-base rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              Buy It Now
              <i className="ri-shopping-bag-line text-lg"></i>
            </a>
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3.5 border-2 border-foreground-200 hover:border-foreground-400 text-foreground-700 font-medium text-base rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              Explore Categories
              <i className="ri-arrow-down-line text-lg"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-12 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
              Updated Product Research
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
              Organized Categories
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
              Buyer Safety Guide
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
              Comparison Resources
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}